import { render, staticRenderFns } from "./MoveLocalStorage.vue?vue&type=template&id=10513d4e&scoped=true"
import script from "./MoveLocalStorage.vue?vue&type=script&lang=js"
export * from "./MoveLocalStorage.vue?vue&type=script&lang=js"
import style0 from "./MoveLocalStorage.vue?vue&type=style&index=0&id=10513d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10513d4e",
  null
  
)

export default component.exports